<template>
  <v-form v-model="valid" ref="indicatorForm">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12>
          <v-select @input="sync" label="Раздел" required :readonly="!!object.parent" v-model="object.category" :items="categoriesOptions" item-value="code" :item-text="`title.${locale}`" :rules="rules.category"></v-select>
        </v-flex>
        <v-flex xs12>
          <v-tabs>
            <v-tab ripple>RU</v-tab>
            <v-tab ripple>KZ</v-tab>
            <v-tab-item>
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea  @input="sync" label="Текст индикатора (РУС)" required v-model="object.title_ru" :counter="5000" :rules="rules.title_ru" />
                </v-flex>
                <v-flex xs12>
                  <v-text-field @input="sync" label="Еденицы измерения (РУС)" v-model="object.unit_ru" :counter="255" :rules="rules.unit_ru"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea  @input="sync" label="Пояснение к индикатору (РУС)" v-model="object.description_ru" :counter="5000" :rules="rules.description_ru" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea  @input="sync" label="Текст индикатора (КАЗ)" required v-model="object.title_kz" :counter="5000" :rules="rules.title_kz" />
                </v-flex>
                <v-flex xs12>
                  <v-text-field @input="sync" label="Еденицы измерения (КАЗ)" v-model="object.unit_kz" :counter="255" :rules="rules.unit_kz"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea  @input="sync" label="Пояснение к индикатору (КАЗ)" v-model="object.description_kz" :counter="5000" :rules="rules.description_kz" />
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>

        <v-flex xs6>
          <v-text-field  @input="sync" label="Баллы" required v-model="object.award" :rules="rules.award" return-masked-value />
        </v-flex>
        <v-flex xs6>
          <v-switch  @change="sync" label="Ключевой индикатор" v-model="object.kpi" />
        </v-flex>
        <v-flex xs6>
          <v-switch  @change="sync" label="Планируемое" v-model="object.planned" />
        </v-flex>
        <v-flex xs6>
          <v-switch  @change="sync" label="Только одно значение" v-model="object.single" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'

import { sortBySequence } from '@/plugins/helpers'

import { Indicator } from '@/api/indicators';

export default {
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: Indicator,
      required: true
    },
    reinit: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    valid: false,
    object: new Indicator(),
    rules: {
      category: [
        v => !!v || 'Необходимо указать раздел'
      ],
      title_ru: [
        v => !!v || 'Обязательное поле',
        v => (v && v.length <= 5000) || 'Максимум 5000 символов'
      ],
      title_kz: [
        v => !!v || 'Обязательное поле',
        v => (v && v.length <= 5000) || 'Максимум 5000 символов'
      ],
      award: [
        v => (v >= 0) || 'Должно быть больше 0'
      ],
      unit_ru: [
        v => ((v === undefined) || (v.length <= 255 || v.length === 0)) || 'Максимум 255 символов'
      ],
      unit_kz: [
        v => ((v === undefined) || (v.length <= 255 || v.length === 0)) || 'Максимум 255 символов'
      ],
      description_ru: [
        v => ((v === undefined) || (v.length <= 5000 || v.length === 0)) || 'Максимум 5000 символов'
      ],
      description_kz: [
        v => ((v === undefined) || (v.length <= 5000 || v.length === 0)) || 'Максимум 5000 символов'
      ]
    }
  }),
  watch: {
    valid (val) {
      this.$emit('on-validate', this.valid)
    },
    reinit (val) {
      if (val) {
        this.init()
      }
    }
  },
  computed: {
    ...mapState('indicators', {
      categories: state => state.categories
    }),
    locale () {
      return this.$i18n.locale
    },
    categoriesOptions () {
      return Object.values(this.categories).sort(sortBySequence)
    }
  },
  mounted () {
    this.init()
    console.log({indicator: this.object})
  },
  methods: {
    init () {
      this.$refs.indicatorForm.resetValidation()
      this.object = new Indicator(this.model)
    },
    sync () {
      console.log({indicator: this.object})
      this.$emit('change', this.object)
    }
  }
}
</script>
